import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		opacity: .3,
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M24 12C24 5.376 18.624 0 12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12ZM7.19766 10.8H11.9977V7.2L16.7977 12L11.9977 16.8V13.2H7.19766V10.8Z",
		fill: "#7074FB"
	})
});
export default SvgArrowRight;
